import './Button.scss';

import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { Link, To } from 'react-router-dom';

export enum ButtonStyle {
  Primary = 'primary',
  Secondary = 'secondary',
  Action = 'action',
  Profile = 'profile',
}

interface IProps {
  type?: 'button' | 'submit' | 'link';
  children?: string | ReactNode | ReactNode[];
  style?: ButtonStyle;
  disabled?: boolean;
  isLoading?: boolean;
  fullWidth?: boolean;
}

interface ILinkProps extends IProps {
  type: 'link';
  to: To;
}

interface IButtonProps extends IProps {
  type?: 'button' | 'submit';
  onClick?: () => void;
}

function Button({
  children,
  disabled,
  isLoading,
  fullWidth,
  type = 'button',
  style = ButtonStyle.Primary,
  ...props
}: ILinkProps | IButtonProps) {
  const className = classNames(`modButton modButton--${style}`, {
    'modButton--disabled': disabled,
    'modButton--loading': isLoading,
    'modButton--full-width': fullWidth,
  });

  const isDisabled = disabled || isLoading;
  return type === 'link' ? (
    <Link className={className} to={(props as ILinkProps).to}>
      {children}
    </Link>
  ) : (
    <button type={type} className={className} disabled={isDisabled} {...props}>
      {children}
    </button>
  );
}

export default Button;
